import * as React from 'react';
import { HEADER_HEIGHT, SIDEBAR_WIDTH } from '../../layout';
import Spinner from '../Spinner';

const SkeletonApp = () => (
  <div className="flex flex-col h-full">
    <div
      className="bg-white shadow-lg flex-none z-20"
      style={{
        height: `${HEADER_HEIGHT}px`
      }}
    >
      <div
        className="shadow-lg h-full"
        style={{
          width: `${SIDEBAR_WIDTH}px`
        }}
      />
    </div>
    <div className="flex-1 flex bg-gray-100">
      <div
        className="bg-white shadow-lg flex-none"
        style={{
          width: `${SIDEBAR_WIDTH}px`
        }}
      />
      <div className="flex-1 flex items-center justify-center">
        <Spinner />
      </div>
    </div>
  </div>
);

export default SkeletonApp;
